import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiCheck } from 'react-icons/fi';

/**
 * Compact step indicator for multi-step flows (e.g. job-card creation).
 * steps: [string]; current: 0-based index. Purely presentational.
 */
export default function Stepper({ steps = [], current = 0, className = '' }) {
  const { t } = useTranslation();
  return (
    <div className={`flex items-center gap-1.5 mt-3 overflow-x-auto scrollbar-hide ${className}`} aria-label={t('cm.progress')}>
      {steps.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <React.Fragment key={i}>
            {i > 0 && <div className={`h-px w-4 sm:w-6 shrink-0 ${done || active ? 'bg-accent' : 'bg-edge-strong'}`} />}
            <div className="flex items-center gap-1.5 shrink-0">
              <span
                className={`flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-bold ${
                  done
                    ? 'bg-accent text-white dark:text-slate-900'
                    : active
                    ? 'bg-accent-soft text-accent-hover dark:text-accent ring-1 ring-accent'
                    : 'bg-surface-2 text-content-muted'
                }`}
              >
                {done ? <FiCheck size={11} /> : i + 1}
              </span>
              <span
                className={`text-xs whitespace-nowrap ${
                  active ? 'font-semibold text-content' : done ? 'text-content-secondary' : 'text-content-muted'
                } hidden sm:inline`}
              >
                {label}
              </span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
